import { Divider, Grid, IconButton, Stack, Table, TableBody, TableContainer, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { MdOutlineModeEdit } from 'react-icons/md';
import SurveyBodyData from '../Components/SurveyBodyData';
import { getSurveyDetails } from '../../../../../../actions/meeting_actions';

const Survey = (props) =>
{
	const { meetingId, handleNavi } = props;
	const initialS = {
		title       : '',
		description : '',
		questions   : []
	};
	const [ surveyData, setSurveyData ] = useState<any>(initialS);

	const getSurveyData = async () =>
	{
		try
		{
			const query:any = {
				sessionId : meetingId
			};

			const res:any = await getSurveyDetails(query);

			if (res?.status)
			{
				setSurveyData((prev) => ({ ...prev,
					title       : res?.data?.title,
					description : res?.data?.description,
					questions   : res?.data?.questions,
					_id         : res?.data?._id
				}));
			}
			else
			{
				setSurveyData(initialS);
			}
		}
		catch (err)
		{
			// eslint-disable-next-line no-console
			console.log('---------------', err);
		}
	};

	useEffect(() =>
	{
		getSurveyData();
	}, []);

	if (surveyData?.questions?.length === 0) return <></>;

	return (
		<>
			<Divider sx={{ border: '1px solid #A3A3A3' }}/>
			<Grid container>
				<Grid item xs={12} mt={'var(--pixel24)'}>
					<Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
						<Typography sx={{ fontWeight: 'var(--font600)', fontSize: 'var(--pixel18)' }}>Survey</Typography>
						<IconButton>
							<MdOutlineModeEdit color='var(--txtColorBlackL)' cursor={'pointer'} onClick={() => handleNavi(6)}/>
						</IconButton>
					</Stack>
					<Stack direction={'column'}>
						<Typography sx={{ fontWeight: 'var(--font500)' }} mt={'var(--pixel8)'}>{surveyData?.title}</Typography>
						<Typography color={'var(--txtColorBlackL)'} mt={1}>{surveyData?.description || ''}</Typography>
					</Stack>
				</Grid>
				<Grid item xs={12}>
					<Stack direction={'column'} mt={1.5}>
						<TableContainer>
							<Table>
								<TableBody>
									{surveyData?.questions?.map((question, index) => (
										<SurveyBodyData
											key={`${question?.question}-${index}`}
											question={question}
										/>
									))}
								</TableBody>
							</Table>
						</TableContainer>
					</Stack>
				</Grid>
			</Grid>
		</>

	);
};

export default Survey;